module.exports = __webpack_public_path__ + "img/information-and-experimental-knowledge-cover.280c2731.jpg";